<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title>電子發票上傳失敗列表</f7-nav-title>
    </f7-navbar>

    <f7-list media-list>
      <f7-list-item
        v-for="(order, index) in orders"
        :key="`store-failed-e-invoices${index}`"
        :title="`${order.nickname}: ${order.invoiceNumber}`"
        :subtitle="order.paidAt | toTimeFormat"
        style="margin-left: 20px;">
        <div slot="inner" style="font-size: 12px; margin: 5px 10px;">
          <div>上傳錯誤記錄：</div>
          <div v-for="(log, index) in order.logData" :key="`store-failed-log-${index}`">
            {{ index + 1 }}. {{ log.replyMessage }}: {{ log.resultMsg }}
          </div>
        </div>
        <div slot="content">
          <f7-button
            v-if="hasOrderPaymentStatusPermission"
            raised
            fill
            color="red"
            style="margin: 10px;"
            @click="setEInvoiceFixed(order.publicId)">
            標記為已修正
          </f7-button>
          <f7-button raised fill style="margin: 10px;" @click="upload(order.publicId)">重新上傳</f7-button>
        </div>
      </f7-list-item>
    </f7-list>
  </f7-page>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { storeClient } from '@/service/apiClients'
import moment from 'moment'

export default {
  dependencies: ['permissionType'],
  data () {
    return {
      orders: []
    }
  },
  filters: {
    toTimeFormat: timestamp => {
      return moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
    },
    toErrorMsgFormat: order => {
      let msg = ''
      msg += order.replyResult
      if (order.replyResult !== 'S') {
        msg += order.replyMessage
      }
      msg += order.resultCode
      if (order.resultCode !== '000') {
        msg += order.resultMsg
      }
      return msg
    }
  },
  computed: {
    ...mapState('userModule', ['permissions']),
    ...mapGetters(['storeId']),
    hasOrderPaymentStatusPermission () {
      return this.permissions['*'] && this.permissions['*'][this.permissionType.updateOrderPaymentStatus]
    }
  },
  async created () {
    await this.setStore(this.storeIdProp)
    this.getFailedEInvoice()
  },
  methods: {
    ...mapActions(['setStore']),
    async setEInvoiceFixed (publicId) {
      await storeClient.post(`/orders/${publicId}/setEInvoiceFixed`)
      this.getFailedEInvoice()
    },
    async getFailedEInvoice () {
      const { data } = await storeClient.get(`/stores/${this.storeId}/failedEInvoices`)
      this.orders = data
    },
    async upload (publicId) {
      await storeClient.get(`/orders/${publicId}/uploadEInvoice`)
      this.getFailedEInvoice()
    }
  },
  props: {
    storeIdProp: String
  }
}
</script>

<style lang="scss" scoped>
.warning {
  color: #856404;
  background-color: #FFF3CD;
  border: solid 1px #FFEEBA;
  border-radius: 5px;
  width: 90%;
  margin: 20px auto;
  padding: 10px 20px;
  box-shadow: 2px 2px 2px #EEEEEE;
  box-sizing: border-box;
}
</style>
